import { verify } from "crypto";
import { createRoom } from "../services/interview-api.services";

export const GAConfig = {
    action: {
        payment: "Payment",
        homePage: "Back Home Page",
        changeLanguage: "Change Language",
         verifyRoom: "Verify Room",
         completeInterview: "Complete Interview",
         confirmData: "Confirm Data",
         createRoom: "Create Room",
         uploadResume: "Upload Resume",
        startRoom: "Start Room",
        completeProfile: "Complete Profi",
        completeInterviewAI: "Complete Interview AI",
        generalInterviewClick: "General Interview Button Click",
        jobSpecificInterviewClick: "Job Specific Interview Button Click",
    }
}